





















import Vue from "@/shim-vue";
import { Component, Prop } from "vue-property-decorator";

import config from "@/config/icon";

@Component({
    name: "LoniIcon"
})
export default class LoniIcon extends Vue {
    /** 图标名称 */
    @Prop({ type: String, required: true })
    public name!: string;

    /** 图标大小，需带单位传入 */
    @Prop()
    public size?: string;

    /** 图标颜色（仅在单色图标下生效） */
    @Prop()
    public color?: string;

    /** 单色模式，将不会使用svg显示图标，这时可以传入一个slot */
    @Prop({ type: Boolean, default: undefined })
    public monochrome?: boolean;

    /** 是否将图标内容居中（这可能会导致图标与周围文本无法在同一行显示） */
    @Prop({ type: Boolean, default: undefined })
    public center?: boolean;

    public get options() {
        return {
            size: this.size ?? config.size,
            color: this.color ?? config.color,
            monochrome: this.monochrome ?? config.monochrome,
            center: this.center ?? config.center
        }
    }
}
